import { SvgIcon } from "@mui/material";

export default function MenuClient(props) {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8232 7.52417C12.1104 7.52417 13.1572 6.47705 13.1572 5.18994C13.1572 3.90283 12.1104 2.85571 10.8232 2.85571C9.53613 2.85571 8.48877 3.90283 8.48877 5.18994C8.48877 6.47705 9.53613 7.52417 10.8232 7.52417ZM12.1572 5.18994C12.1572 5.92554 11.5586 6.52417 10.8232 6.52417C10.0874 6.52417 9.48877 5.92554 9.48877 5.18994C9.48877 4.45435 10.0874 3.85571 10.8232 3.85571C11.5586 3.85571 12.1572 4.45435 12.1572 5.18994Z"
          fill="#979797"
        />
        <path
          d="M10.8252 8.27417C10.3545 8.27417 9.90431 8.34961 9.48682 8.49829C9.22706 8.59082 9.09132 8.87695 9.1836 9.13696C9.26832 9.37436 9.51341 9.49896 9.75425 9.45001C9.77717 9.44534 9.80006 9.44824 9.82276 9.44019C10.1318 9.33008 10.4692 9.27417 10.8252 9.27417C11.6748 9.27417 12.4727 9.604 13.0713 10.2026C13.6699 10.8015 14 11.5994 14 12.4492C14 12.635 13.9277 12.8093 13.7964 12.9409C13.665 13.072 13.4927 13.1443 13.3101 13.1443H10.6201C10.5849 13.1443 10.5541 13.1574 10.5209 13.1643C10.2939 13.2116 10.1201 13.4033 10.1201 13.6443C10.1201 13.9204 10.3438 14.1443 10.6201 14.1443H13.3101C13.7598 14.1443 14.1836 13.9678 14.5034 13.6479C14.8237 13.3279 15 12.9023 15 12.4492C15 11.3323 14.5659 10.2834 13.7783 9.49561C12.9907 8.70801 11.9419 8.27417 10.8252 8.27417Z"
          fill="#979797"
        />
        <path
          d="M5.17676 7.52417C6.46387 7.52417 7.51123 6.47705 7.51123 5.18994C7.51123 3.90283 6.46387 2.85571 5.17676 2.85571C3.88965 2.85571 2.84277 3.90283 2.84277 5.18994C2.84277 6.47705 3.88965 7.52417 5.17676 7.52417ZM5.17676 3.85571C5.9126 3.85571 6.51123 4.45435 6.51123 5.18994C6.51123 5.92554 5.9126 6.52417 5.17676 6.52417C4.44141 6.52417 3.84277 5.92554 3.84277 5.18994C3.84277 4.45435 4.44141 3.85571 5.17676 3.85571Z"
          fill="#979797"
        />
        <path
          d="M2.69141 14.1426H7.6626C8.59521 14.1426 9.354 13.3838 9.354 12.4512C9.354 10.1479 7.47998 8.27417 5.17676 8.27417C2.87354 8.27417 1 10.1479 1 12.4512C1 13.3838 1.75879 14.1426 2.69141 14.1426ZM5.17676 9.27417C6.92871 9.27417 8.354 10.6995 8.354 12.4512C8.354 12.8325 8.04395 13.1426 7.6626 13.1426H2.69141C2.31006 13.1426 2 12.8325 2 12.4512C2 10.6995 3.42529 9.27417 5.17676 9.27417Z"
          fill="#979797"
        />
      </svg>
    </SvgIcon>
  );
}
